import React, { useEffect } from 'react';
import { Row, Col } from 'reactstrap';

import { Datepicker, Intl } from 'components';
import moment from 'moment';
import { useSelector } from 'react-redux';

export default ( { currentStep, form, values } ) => {
  const userData = useSelector(state => state.user);
  useEffect( () => {
    const interval = setInterval( () => {
      if ( currentStep === 1 && values && values.timeZone ) {
        const date = `${moment( values.startDate ).format( 'YYYY-MM-DD' )} ${moment( values.startTime ).format( 'HH:mm' )}`;
        if ( moment.tz( date, 'YYYY-MM-DD HH:mm', true, values.timeZone ).diff( moment.tz( values.timeZone ), 'minutes', true ) <= 0 ) {
          form.change( 'startTime', moment.tz( values.timeZone ) );
        }
      }
    }, 1000 );
    return () => {
      clearInterval( interval );
    };
  }, [currentStep, values] ); // eslint-disable-line

  return (
    <>
      <Row className="mt-5">
        <Col md={7} className="m-auto">
          <Row>
            <Col md={6}>
              <Datepicker
                field="startDate"
                dateFormat="YYYY-MM-DD"
                formGroupClass="m-md-0"
                startDateField={{ value: moment.tz( values.timeZone ).subtract( 1, 'day' ) }}
                appendIconClass="far fa-calendar"
                onBlur={() => {
                  if ( values.startDate && values.startTime ) {
                    const date = `${moment( values.startDate ).format( 'YYYY-MM-DD' )} ${moment( values.startTime ).format( 'HH:mm' )}`;
                    if ( moment.tz( date, 'YYYY-MM-DD HH:mm', true, values.timeZone ).diff( moment.tz( values.timeZone ), 'minutes' ) <= 0 ) {
                      form.change( 'startDate', moment.tz( values.timeZone ) );
                      form.change( 'startTime', moment.tz( values.timeZone ) );
                    }
                  }
                }}
              />
            </Col>
            <Col md={6}>
              <Datepicker
                field="startTime"
                dateFormat={false}
                timeFormat="H:mm"
                formGroupClass="m-0"
                appendIconClass="far fa-clock"
                showErrors={false}
                validate={( value ) => {
                  if ( value ) {
                    const date = moment.tz( value, 'YYYY-MM-DD HH:mm', true, values.timeZone ).format( 'HH:mm' );
                    // if ( date >= '21:00' || date < '09:00' ) {
                    if ( date >= userData.to_time || date < userData.from_time ) {
                      return 'INVALID';
                    }
                  }
                }}
                onBlur={() => {
                  if ( values.startDate && values.startTime ) {
                    const date = `${moment( values.startDate ).format( 'YYYY-MM-DD' )} ${moment( values.startTime ).format( 'HH:mm' )}`;
                    if ( moment.tz( date, 'YYYY-MM-DD HH:mm', true, values.timeZone ).diff( moment.tz( values.timeZone ), 'minutes' ) <= 0 ) {
                      form.change( 'startDate', moment.tz( values.timeZone ) );
                      form.change( 'startTime', moment.tz( values.timeZone ) );
                    }
                  }
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>

      <Row className="mt-5">
        <Col className="text-center text-sm">
          <Intl id="campaignOddHours" />
        </Col>
      </Row>
    </>
  );
};
